var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUploadCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 13.5C6.99999 14.0523 7.4477 14.5 7.99999 14.5C8.55227 14.5 8.99999 14.0523 8.99999 13.5L8.99999 5.91424L11.2928 8.20708C11.6834 8.5976 12.3165 8.5976 12.707 8.20708C13.0976 7.81655 13.0976 7.18339 12.707 6.79286L8.70706 2.79289C8.31653 2.40237 7.68337 2.40237 7.29285 2.79289L7.28341 2.80245L3.29288 6.79299C2.90235 7.18351 2.90235 7.81667 3.29288 8.2072C3.6834 8.59772 4.31657 8.59772 4.70709 8.2072L6.99999 5.91431L6.99999 13.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUploadCv);
export default __webpack_public_path__ + "static/media/arrow-upload-cv.f7e4c085075978210ca01407eeafcd65.svg";
export { ForwardRef as ReactComponent };